import { Suspense, lazy, useEffect } from 'react';

import { ECompanyStep, usePersonalStore } from '@/entities/user';

import { ROUTES, useNavigate } from '@/shared/lib';
import { PageLoader } from '@/shared/ui';

const RegistrationRoutesLayoutAsync = lazy(() => import('./ui/RoutesLayout'));

export const RegistrationRoutesLayout = () => {
  const navigate = useNavigate();
  const user = usePersonalStore((state) => state.user);
  const company = usePersonalStore((state) => state.company);

  const hasAccessToken = Boolean(localStorage.getItem('@accessToken'));

  useEffect(() => {
    if (user && !user.isRegistered) return;

    if (!hasAccessToken || !user) {
      void navigate(ROUTES.WELCOME, { replace: true });
      return;
    }

    if (
      !company?.step ||
      company.step !== ECompanyStep.CompanyOnboardingCompleted
    ) {
      void navigate(ROUTES.KYB_QUESTIONNAIRE, { replace: true });
      return;
    }
  }, [user, company]);

  if (!hasAccessToken || !user) return null;
  return (
    <Suspense fallback={<PageLoader />}>
      <RegistrationRoutesLayoutAsync />
    </Suspense>
  );
};
